export const FETCH_LOADING = "FETCH_LOADING"
export const FETCH_FAILED = "FETCH_FAILED"
export const FETCH_BOOKS_SUCCESS = "FETCH_BOOKS_SUCCESS"
export const FILTER_BOOKS_BY_READ = "FILTER_BOOKS_BY_READ"
export const SEARCH_BOOKS = "SEARCH_BOOKS"